module.exports = __webpack_public_path__ + "static/media/background-color.64e0a1c2.svg";